import React from "react";
import {useTranslation} from "react-i18next";
import FormField from "../../Common/FormField";
import SelectField from "../../Common/SelectField";
import {Heading, SelectOption} from "@americanexpress/dls-react";
import {COUNTRIES_WITH_CITY_FIELD, PA_COUNTRIES} from "../../Common/constants";

const PersonalInfoSection = ({ formik, isModifyUser, country }) => {
  const { t } = useTranslation("common");
  const isIEC = country === t(`access.INTERNATIONALEUROCARD`);

  function getMarketPrefix() {
    return isIEC ? "newUserIEC" : "newUserUK";
  }

  function getPersonalInfoSectionHeading() {
    const heading = isModifyUser ? "modifyPersonalHeading" : "personalInfoHeading";
    const prefix = (isIEC && isModifyUser) ? "newUserUK" : getMarketPrefix();
    return t(`${prefix}.${heading}`);
  }

  return (
    <section id="personal-info">
      <div className="row pad-2-t">
        <div className="col-xs-12">
          {isModifyUser && <Heading
            level={4}
            className="heading-4 dls-deep-blue pad-2-t pad-1-b"
          >
            {t("newuser.modifyPersonalHeading")}
          </Heading>}
          <h4 className="heading-4 dls-deep-blue pad-2-b">
            {getPersonalInfoSectionHeading()}
          </h4>
        </div>
      </div>
      <div className="row">
        <FormField
          id="firstName"
          name="firstName"
          label={t("newUserUK.fullFirstName")}
          value={formik.values.firstName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.firstName && formik.errors.firstName}
        />
        <FormField
          id="fullMiddleName"
          name="fullMiddleName"
          label={t("newUserUK.fullMiddleName")}
          value={formik.values.fullMiddleName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <FormField
          id="fullLastName"
          name="lastName"
          label={t("newUserUK.fullLastName")}
          value={formik.values.lastName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.lastName && formik.errors.lastName}
        />
        <FormField
          id="paAddress"
          name="paAddress"
          label={t(`${getMarketPrefix()}.paResAdd`)}
          value={formik.values.paAddress}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.paAddress && formik.errors.paAddress}
        />
        <FormField
          id="paPostcode"
          name="paPostcode"
          label={t("newUserUK.postCode")}
          value={formik.values.paPostcode}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.paPostcode && formik.errors.paPostcode}
        />
        <FormField
          id="countryUK"
          name="countryUK"
          label={t("newUserUK.countryUK")}
          value={formik.values.countryUK}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.countryUK && formik.errors.countryUK}
        />
        <SelectField
          id="paCountry"
          name="paCountry"
          label={t("newuser.paPrimaryCountry")}
          value={formik.values.paCountry}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          hint={isIEC ? t("newUserUK.paCountryForLangInfoIEC") : t("newUserUK.paCountryForLangInfo")}
          error={formik.touched.paCountry && formik.errors.paCountry}
        >
          <SelectOption value="" />
          {PA_COUNTRIES.map((country) => (
            <SelectOption key={country} value={country} data-label={country}>
              {country}
            </SelectOption>
          ))}
        </SelectField>

        <FormField
          id="paExistingInfo"
          name="paExistingInfo"
          label={t("newUserUK.paExitInfo")}
          value={formik.values.paExistingInfo}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          hint={t("newUserUK.paExitInfoTip")}
          error={formik.touched.paExistingInfo && formik.errors.paExistingInfo}
        />
        {COUNTRIES_WITH_CITY_FIELD(t).includes(country) && (
          <FormField
            id="city"
            name="city"
            label={t("newuser.city")}
            value={formik.values.city}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.city && formik.errors.city}
          />
        )}
      </div>
    </section>
  );
};

export default PersonalInfoSection;
